import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const TableTennis = () => {
  return (
    <SportsLayoutComp name={'Table Tennis'}/>
  )
}

export default TableTennis